import RadioAntd from "antd/lib/radio";
import { WrapperInput } from "components/core";
import styled from "styled-components";

const RadioGroup = styled(RadioAntd.Group)`
  padding: 1em 8px 0;
  font-size: inherit;
  span {
    color: #fff;
  }

  span.ant-radio span.ant-radio-inner {
    background-color: transparent !important;
    border-radius: 2px;
  }
`;

export const Radio = ({
  options = [],
  defaultValue = "",
  onChange = () => {},
  disabled = false,
  name = "",
  xs,
  md,
  classMain,
  classLabel,
  label,
}) => {
  return (
    <WrapperInput
      xs={xs}
      md={md}
      classMain={classMain}
      classLabel={classLabel}
      label={label}
    >
      <RadioGroup
        options={options}
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
        name={name}
      />
    </WrapperInput>
  );
};
